import { onError } from '@apollo/client/link/error';
import { ServerParseError } from '@apollo/client';
import {
  AppLogger,
  LogTypes,
  DatadogClient,
  AuthClient,
} from '@workivate/tho-web-shared';

import { sessionInvalidationHTTPStatus } from 'wa-storybook/components/modal/session-invalidation-alert-modal/constants';

const errorLink = () =>
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(error => {
        DatadogClient.addError(error);
        DatadogClient.logMessage(
          `[GraphQL error]: Message: ${error.message}, Location: ${error.locations}, Path: ${error.path}`,
        );
      });
    }
    if (networkError) {
      DatadogClient.addError(networkError);
      DatadogClient.logMessage(
        `[GraphQL error][Network error]: ${JSON.stringify(networkError)}`,
      );

      if (
        (networkError as ServerParseError).statusCode ===
        sessionInvalidationHTTPStatus
      ) {
        AppLogger.logWithOptions({
          message: 'Attempting token refresh after 401 GraphQL error',
          level: LogTypes.Log,
          shouldLogToDatadog: true,
        });

        // We refresh the tokens to see if this is session expiry
        // if refresh fails, AuthEvents.subscribe in run-with-usl.tsx will handle logout
        AuthClient.refreshTokens().catch(() => {
          // This prevents unhandled promise rejection
        });
      }
    }
  });

export default errorLink;
